import React from "react";
import ReactDOM from "react-dom";

import { PortalPropsType } from "./types";

export const Portal: React.FC<PortalPropsType> = ({ children }) => {
  const defaultContainer = document.body;

  return ReactDOM.createPortal(
    // @ts-expect-error - ReactDOM.createPortal имеет проблемы с типами в React 18
    <div className="portal">{children}</div>,
    defaultContainer
  );
};
